var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCustomDoneAll = function SvgCustomDoneAll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.638 7.195c.369.302.423.846.121 1.216L8.511 17.27a1.727 1.727 0 0 1-2.373.288l-2.792-2.094a.864.864 0 1 1 1.036-1.382l2.792 2.094 7.248-8.86a.864.864 0 0 1 1.216-.12Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.638 7.195c.369.302.423.846.121 1.216L8.511 17.27a1.727 1.727 0 0 1-2.373.288l-2.792-2.094a.864.864 0 1 1 1.036-1.382l2.792 2.094 7.248-8.86a.864.864 0 0 1 1.216-.12Z",
    stroke: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m11.523 16.997.634.507c.74.592 1.816.478 2.416-.255l7.232-8.838a.864.864 0 0 0-1.337-1.094l-7.232 8.839-.619-.495-1.094 1.336Z",
    fill: "currentColor"
  })));
};

export default SvgCustomDoneAll;